
import React from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import { EmailOutlined } from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ApiForgotPassword } from "../../Core/Apicall";
// Import your forgot-password API here.

function ForgotPassword() {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter a valid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values) => {
      try {
        // Replace with your actual API:
        
        await ApiForgotPassword({
          email: values.email.trim().toLowerCase(),
        });

        // Navigate only after the API succeeds.
        navigate("/verify-otp", {
          state: { email: values.email.trim().toLowerCase() },
        });
      } catch (error: any) {
        toast.error(
          error?.message || "Unable to send OTP. Please try again."
        );
      }
    },
  });

  return (
    <Box className="p-3 p-lg-5 d-flex align-items-center justify-content-center h-100 w-100">
      <Box
        className="p-3 p-lg-5 d-flex flex-column w-100 border-10"
        sx={{
          maxWidth: 700,
          border: { xs: "none", md: "1px solid #ccc" },
        }}
      >
        <Typography variant="h5" className="text-center fw-bold">
          Forgot Password?
        </Typography>

        <Typography className="text-center text-grey mt-2 mb-4">
          Enter your registered email address and we'll send you an OTP to
          reset your password.
        </Typography>

        <Box component="form" className="form-text-field" onSubmit={formik.handleSubmit}>
          <Typography className="fw-bold mb-2">
            Email Address
          </Typography>

          <TextField
            fullWidth
            name="email"
            type="email"
            placeholder="Enter your registered email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutlined />
                  </InputAdornment>
                ),
              },
            }}
          />

          <Button
            type="submit"
            fullWidth
            className="btn-main border-10 mt-4"
            sx={{ py: 1.5 }}
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? "Sending OTP..." : "Send OTP"}
          </Button>
        </Box>

        <Typography className="text-center mt-4">
          Remember your password?{" "}
          <Link to="/" className="text-main">
            Log In
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}

export default ForgotPassword;
